import { requestJSON } from './http';

const create = (studentEmailOrId, message, attachments, specialConsideration) =>
  requestJSON('/staff/messages', 'POST', { studentEmailOrId, message, attachments, specialConsideration });

export default {
  create,
};
